import {BaseAppModel} from "./AppModel";
import {MqttEvent} from "@/module/mqtt/MqttEvent";

export enum MqttEventType {
    CLIENT_CONNECTED = "CLIENT_CONNECTED",
    CLIENT_DISCONNECTED = "CLIENT_DISCONNECTED",
    MESSAGE_PUBLISH = "MESSAGE_PUBLISH",
    SESSION_SUBSCRIBED = "SESSION_SUBSCRIBED",
    SESSION_UNSUBSCRIBED = "SESSION_UNSUBSCRIBED",
    UNKNOWN = "UNKNOWN"
}

export default class MqttEventWrapper extends BaseAppModel<MqttEventWrapper> {
    eventType!: MqttEventType
    eventJson!: string
    event!: MqttEvent
}
